import { Component, Input } from '@angular/core'
import { WorkItem } from '../../work-item'
import { ProductionLine } from '../../production-line'
import { Duration } from '@js-joda/core'
import { JsonMap } from '../../../common/json-map'
import { WorkCenterMeta } from '../../work-center'
import { MatBadge } from '@angular/material/badge'
import { ElderChipLabelDirective, IsoDurationPipe } from '@elderbyte/ngx-starter'

import { MatChip, MatChipSet } from '@angular/material/chips'
import { ThemePalette } from '@angular/material/core'

@Component({
  selector: 'app-job-detail-production-line-view',
  templateUrl: './job-detail-production-line-view.component.html',
  styleUrls: ['./job-detail-production-line-view.component.scss'],
  imports: [MatChipSet, MatChip, ElderChipLabelDirective, MatBadge, IsoDurationPipe],
})
export class JobDetailProductionLineViewComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  @Input()
  public workItem: WorkItem | null = null

  @Input()
  public assignments: JsonMap<string> = {}

  @Input()
  public wcMetas: JsonMap<WorkCenterMeta> = {}

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public getChipColor(productionLineId: string): ThemePalette {
    const item = this.workItem
    if (!!item && this.assignments != null && this.assignments[item.id] === productionLineId) {
      return 'accent'
    }
    if (!!item && item.currentProductionLineId === productionLineId) {
      return 'primary'
    }
    return undefined
  }

  public hasValidMakespan(productionLine: ProductionLine): boolean {
    return productionLine.workCenters.some((wc) => wc.makespan !== Duration.ZERO.toString())
  }
}
